(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('ControllerPaymentDialogController',ControllerPaymentDialogController);

    ControllerPaymentDialogController.$inject = ['$scope','entity','controller','ControllerPayment','$uibModalInstance','ToastrService','MiscService'];

    function ControllerPaymentDialogController($scope, entity, controller, ControllerPayment, $uibModalInstance, ToastrService, MiscService) {
        var vm = this;

        vm.cp = entity;
        vm.cp.controller = controller;
        if(vm.cp.id !== null) {
            vm.cp.paymentDate = MiscService.dateFix(vm.cp.paymentDate);
        }

        vm.save = save;
        vm.clear = clear;
        vm.openCalendar = openCalendar;
        vm.onTextClick = onTextClick;
        vm.setScale = setScale;
        vm.updateAmountDisplay = updateAmountDisplay;

        vm.datePickerOpenStatus = {
            paymentDate: false
        };

        function openCalendar(date) {
            vm.datePickerOpenStatus[date] = true;
        }

        function save() {
            vm.isSaving = true;
            if(vm.cp.id === null) {
                ControllerPayment.save(vm.cp, onSaveSuccess, onSaveError);
            } else {
                ControllerPayment.update(vm.cp, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess(result) {
            vm.isSaving = false;
            $scope.$emit('ccsTrApp:controllerPaymentUpdate',result);
            ToastrService.success("Successfully save Payment","Success!");
            $uibModalInstance.close(result);
        }

        function onSaveError() {
            ToastrService.error("Failed to save Payment","Error");
            vm.isSaving = false;
        }

        function clear() {
            $uibModalInstance.dismiss('cancel');
        }

        function updateAmountDisplay() {
            vm.cp.amountDisplay = vm.cp.currency + " " + vm.cp.amount;
        }

        function setScale(value, scale) {
            return parseFloat(value).toFixed(scale);
        }

        function onTextClick($event) {
            $event.target.select();
        }
    }
})();
